var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("StarRating", {
    staticClass: "rating",
    attrs: {
      rating: _vm.value,
      "star-size": _vm.starSize,
      "show-rating": _vm.ratingShown,
      "read-only": _vm.readOnly,
      increment: _vm.increment,
      "fixed-points": 1,
    },
    on: { "rating-selected": (val) => _vm.$emit("input", val) },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }